import styled from 'styled-components';
import { Breadcrumbs as MuiBreadcrumbs } from '@material-ui/core';

export const Wrapper = styled(MuiBreadcrumbs)`
&.MuiBreadcrumbs-root {
  margin: 24px 0 21px;
  @media (min-width: 600px) {
    margin: 33px 0 11px; 
  }
}

.MuiBreadcrumbs-separator, a {
  font-size: 10px;
}
`